<template>
  <div class="my-user-item-container" :class="className">
    <div class="my-row">
      <div class="my-div">
        <b class="my-bold">{{ item.sn }}</b> ,
        <b class="my-bold">{{ item.address }}</b>
      </div>
    </div>
    <div class="my-row">
      <div class="my-col">
        <div class="my-div">
          {{ item.krugName }}
        </div>
        <div class="my-div">
          <simple-item-ts-card :ts="item.lastMessageTS"></simple-item-ts-card>
        </div>
        <div class="my-div">
          К: {{ item.k || 0 }} &#8381;; М: {{ item.m || 0 }}
          &#8381;
        </div>
        <div class="my-div my-message-item" v-if="item.online == 0">
          Нет связи
        </div>

        <div
          class="my-div"
          v-if="!(item.currentErrorCode == 255 && item.currentErrorDevice)"
        >
          <div class="my-div">Ошибка:</div>
          <b class="my-bold my-message-item"
            >{{ (item && devicesModel[item.currentErrorDevice]) || "-" }} :
            {{ (item && errorsModel[item.currentErrorCode]) || "-" }}</b
          >
        </div>
        <div class="my-div">
          <div class="my-div">
            <div
              v-if="item && item.currentMessages && item.currentMessages.length"
            >
              <div class="my-div">Сообщения:</div>
              <div
                v-for="(msgKey, index) in item.currentMessages"
                :key="index"
                class="my-message-item"
              >
                {{ messagesModel[msgKey] || msgKey }}
              </div>
            </div>
          </div>
        </div>
        <div class="my-div" v-if="hasCmdInQueue">
          Команда:
          <b class="my-bold">{{
            (item && item.cmdProfile && commands[item.cmdProfile.cmd]) || "-"
          }}</b>
        </div>
      </div>
      <div class="my-col">
        <div class="my-div">
          <md-button
            class="my-button md-success"
            @click.native="showMessages(item.sn)"
          >
            Сообщения
          </md-button>
        </div>
        <div class="my-div">
          <md-button
            v-if="!hasCmdInQueue"
            class="my-button md-info"
            @click.native="onControl(item.sn)"
          >
            Управлять
          </md-button>

          <md-button
            v-else
            class="my-button md-danger"
            @click.native="showDropDialog = true"
          >
            Отменить
          </md-button>
          <md-dialog-confirm
            :md-active.sync="showDropDialog"
            md-title="Отменить операцию"
            :md-content="confirmText(commands[item.cmdProfile.cmd])"
            md-confirm-text="Подтверждаю"
            md-cancel-text="Отмена"
            @md-cancel="showDropDialog = false"
            @md-confirm="dropCmd(item.sn)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleItemTsCard from "../common/SimpleItemTSCard.vue";

export default {
  name: "cmd-card",
  components: { SimpleItemTsCard },
  props: {
    messagesModel: {
      type: Object,
      default: () => {
        return {};
      },
    },
    filterSn: {
      type: String,
      default: () => {
        return "";
      },
    },
    errorsModel: {
      type: Object,
      default: () => {
        return {};
      },
    },
    devicesModel: {
      type: Object,
      default: () => {
        return {};
      },
    },
    item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showDropDialog: false,
      commands: {
        "app:on": "Включить аппарат",
        "app:off": "Выключить аппарат",
        "app:reset": "Перегрузить аппарат",
        "tara:off": "Выключить бесплатный налив",
        "tara:on": "Включить бесплатнгый налив",
        "tara:pop": "Пополнить тару",
        "temp:off": "Выключить обогреватель",
        "temp:on": "Включить обогреватель",
        "kup:off": "Выключить купюроприёмникник",
        "kup:on": "Включить купюроприёмник",
        "mon:off": "Выключить монетоприёмник",
        "mon:on": "Включить монетоприёмник",
        "rd:off": "Выключить модуль б/н оплаты",
        "rd:on": "Включить модуль б/н оплаты",
        "alarm:off": "Выключить сигнализацию",
        "san:on": "Вкл. Санитарную обработку",
        "san:off": "Выкл. Санитарную обработку",
        info: "Запросить состояние",
        inkas1: "Cлот #1",
        inkas2: "Слот #2",
        inkas3: "Слот #3",
        inkas4: "Слот #4",
        inkas5: "Слот #5",
        inkas6: "Слот #6",
        inkas7: "Слот #7",
      },
    };
  },
  methods: {
    showMessages(sn) {
      this.$router.push({
        path: "/EngMessages",
        query: { sn, filterSn: this.filterSn, item: this.item },
      });
    },
    confirmText(cmdTitle) {
      return `Подтверждаете операцию "${cmdTitle}" ?`;
    },
    onControl(sn) {
      this.$router.push({
        path: "/EngControl",
        query: { sn, filterSn: this.filterSn, item: this.item },
      });
    },
    showSuccessNotify(r) {
      this.$notify({
        message: `<h3>${r.title}</h3>` + `<p>${r.message}</p>`,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success",
      });
    },
    showErrorNotify(r) {
      this.$notify({
        message: `<h3>${r.errorCode}</h3>` + `<p>${r.errorMessage}</p>`,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "warning",
      });
    },
    dropCmd(sn) {
      this.showDropDialog = false;

      this.ajax.dropCmdByEng(
        this,
        {
          sn,
        },
        (r) => {
          if (r.status == "ok") {
            // this.$emit("needToRefresh");
            this.$set(this.item, "cmdProfile", {});
            this.showSuccessNotify({
              title: "OK",
              message: "Команда отменена",
            });
          } else {
            this.showErrorNotify(r);
          }
        },
        (err) => {
          // console.log(err);
        }
      );
    },
  },
  mounted() {},
  watch: {},
  computed: {
    className() {
      if (this.hasErrors) return "error-box";
      if (this.hasWarning) return "warning-box";
      return "";
    },
    hasErrors() {
      if (this.item?.online != 1) {
        return true;
      } else {
        let __errorCode = this.item?.currentErrorCode || 255;
        return this.item && __errorCode != 255;
      }
    },
    hasWarning() {
      return this.item && this.item.currentMessages.length > 0;
    },
    hasCmdInQueue() {
      return !!(
        this.item?.cmdProfile && Object.keys(this.item.cmdProfile).length
      );
    },
  },
};
</script>

<style lang="css" scoped>
.my-user-item-container {
  margin-top: 0px;
  margin-bottom: 2px;
  border: solid 1px green;
  border-radius: 3px;
  padding: 5px;
}

.my-col {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.my-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
}

.my-div {
  margin-right: 0px;
  margin: 0px;
  padding: 0px;
}

.my-grow {
  flex-grow: 1;
}

.my-button {
  margin: 2px;
  padding: 1px;
  height: 38px;
  width: 100px;
}

.my-bold {
  font-weight: bold;
}

.error-box {
  background-color: #ffe0e0;
  border-color: #ff0000;
}

.warning-box {
  border: 1px solid #c48f00;
  background-color: #fff4cc;
}

.my-button-danger {
  background-color: #d9534f;
  color: #fff;
}

.my-col:last-child {
  gap: 10px;
}

.my-message-item {
  color: red;
  font-weight: bold;
}
</style>
